export default '/pricing/check-protection';
